import React, { useState } from 'react';
import { LayoutDashboard, Heart, MessageSquare, Settings, User, Bell, Shield, CreditCard, HelpCircle } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MessageModal } from '../../components/modals/MessageModal';
import { ConfirmModal } from '../../components/modals/ConfirmModal';
import { ChangePasswordModal } from '../../components/modals/ChangePasswordModal';
import { Setup2FAModal } from '../../components/modals/Setup2FAModal';
export function SettingsPage() {
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [isSetup2FAOpen, setIsSetup2FAOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    type: 'info' as 'success' | 'error' | 'info'
  });
  const handleSavePreferences = () => {
    setModalContent({
      title: 'Preferences Saved',
      message: 'Your preferences have been updated successfully.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const handleDeleteAccount = () => {
    setModalContent({
      title: 'Account Deleted',
      message: "Your account has been permanently deleted. We're sorry to see you go.",
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'Shortlisted',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'My Inquiries',
    icon: MessageSquare,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  return <DashboardLayout title="Buyer Dashboard" navItems={navItems} userInitials="AB" data-id="element-3065">
      <h1 className="text-2xl font-bold mb-8" data-id="element-3066">Account Settings</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3067">
        {/* Main Settings */}
        <div className="lg:col-span-2 space-y-6" data-id="element-3068">
          {/* Profile Settings */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-3069">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-3070">
              <User className="w-5 h-5" data-id="element-3071" /> Profile Information
            </h2>
            <div className="space-y-4" data-id="element-3072">
              <div className="grid grid-cols-2 gap-4" data-id="element-3073">
                <div data-id="element-3074">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3075">
                    First Name
                  </label>
                  <input type="text" defaultValue="Amit" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3076" />
                </div>
                <div data-id="element-3077">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3078">
                    Last Name
                  </label>
                  <input type="text" defaultValue="Patel" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3079" />
                </div>
              </div>
              <div data-id="element-3080">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3081">
                  Email
                </label>
                <input type="email" defaultValue="amit.patel@example.com" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3082" />
              </div>
              <div data-id="element-3083">
                <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3084">
                  Phone
                </label>
                <input type="tel" defaultValue="+91 98765 43210" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3085" />
              </div>
              <button onClick={handleSavePreferences} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3086">
                Save Changes
              </button>
            </div>
          </div>

          {/* Notification Preferences */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-3087">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-3088">
              <Bell className="w-5 h-5" data-id="element-3089" /> Notifications
            </h2>
            <div className="space-y-3" data-id="element-3090">
              {[{
              label: 'Email notifications for new inquiries',
              checked: true
            }, {
              label: 'SMS alerts for price drops',
              checked: false
            }, {
              label: 'Weekly digest of new listings',
              checked: true
            }, {
              label: 'Marketing and promotional emails',
              checked: false
            }].map((item, i) => <label key={i} className="flex items-center gap-3" data-id="element-3091">
                  <input type="checkbox" defaultChecked={item.checked} className="w-4 h-4" data-id="element-3092" />
                  <span className="text-sm" data-id="element-3093">{item.label}</span>
                </label>)}
            </div>
          </div>
        </div>

        {/* Security Sidebar */}
        <div className="space-y-6" data-id="element-3094">
          <div className="bg-white border border-gray-300 p-6" data-id="element-3095">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-3096">
              <Shield className="w-5 h-5" data-id="element-3097" /> Security
            </h2>
            <div className="space-y-3" data-id="element-3098">
              <button onClick={() => setIsChangePasswordOpen(true)} className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3099">
                Change Password
              </button>
              <button onClick={() => setIsSetup2FAOpen(true)} className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3100">
                Setup 2FA
              </button>
              <button className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3101">
                Active Sessions
              </button>
            </div>
          </div>

          <div className="bg-white border border-gray-300 p-6" data-id="element-3102">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-3103">
              <CreditCard className="w-5 h-5" data-id="element-3104" /> Billing
            </h2>
            <div className="space-y-3" data-id="element-3105">
              <button className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3106">
                Payment Methods
              </button>
              <button className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3107">
                Transaction History
              </button>
            </div>
          </div>

          <div className="bg-white border border-gray-300 p-6" data-id="element-3108">
            <h2 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-3109">
              <HelpCircle className="w-5 h-5" data-id="element-3110" /> Support
            </h2>
            <div className="space-y-3" data-id="element-3111">
              <button className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3112">
                Help Center
              </button>
              <button className="w-full text-left px-4 py-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium" data-id="element-3113">
                Contact Support
              </button>
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 p-6" data-id="element-3114">
            <h3 className="font-bold text-red-900 mb-2" data-id="element-3115">Danger Zone</h3>
            <p className="text-xs text-red-700 mb-4" data-id="element-3116">
              Once you delete your account, there is no going back.
            </p>
            <button onClick={() => setIsConfirmModalOpen(true)} className="w-full py-2 bg-red-600 text-white text-sm font-bold hover:bg-red-700" data-id="element-3117">
              Delete Account
            </button>
          </div>
        </div>
      </div>

      <ChangePasswordModal isOpen={isChangePasswordOpen} onClose={() => setIsChangePasswordOpen(false)} data-id="element-3118" />

      <Setup2FAModal isOpen={isSetup2FAOpen} onClose={() => setIsSetup2FAOpen(false)} data-id="element-3119" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type={modalContent.type} data-id="element-3120" />

      <ConfirmModal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)} onConfirm={handleDeleteAccount} title="Delete Account" message="Are you sure you want to permanently delete your account? This action cannot be undone and all your data will be lost." confirmText="Delete My Account" type="danger" data-id="element-3121" />
    </DashboardLayout>;
}